/* tslint:disable */
/* eslint-disable */
/**
 * EVIMO API
 * Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ListSchedulesResponseDto,
} from '../models/index';
import {
    ListSchedulesResponseDtoFromJSON,
    ListSchedulesResponseDtoToJSON,
} from '../models/index';

export interface ScheduleControllerFindAllRequest {
    planId: string;
}

/**
 * 
 */
export class PreventiveMaintenanceSchedulesApi extends runtime.BaseAPI {

    /**
     */
    async scheduleControllerFindAllRaw(requestParameters: ScheduleControllerFindAllRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ListSchedulesResponseDto>> {
        if (requestParameters['planId'] == null) {
            throw new runtime.RequiredError(
                'planId',
                'Required parameter "planId" was null or undefined when calling scheduleControllerFindAll().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/v1/preventive-maintenance/plans/{planId}/schedules`;
        urlPath = urlPath.replace(`{${"planId"}}`, encodeURIComponent(String(requestParameters['planId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ListSchedulesResponseDtoFromJSON(jsonValue));
    }

    /**
     */
    async scheduleControllerFindAll(requestParameters: ScheduleControllerFindAllRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ListSchedulesResponseDto> {
        const response = await this.scheduleControllerFindAllRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
